















































import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";


const paginationDefault = {
	sortBy: "",
	descending: false,
	rowsPerPage: 10,
	page: 1
};

/**
 * Data table component (not used).
 */
@Component
export default class DataTable extends Vue {
	/// Properties
	@Prop({required: true})
	headers!: any[];

	@Prop()
	items!: any[];

	@Prop()
	search!: string;

	@Prop({default: () => paginationDefault})
	pagination!: any;


	/// Attributes
	paginationDefault: any | null = null;
	fetchedItems: any[] | null = null;
	totalItems: number | null = null;
	isLoading = false;

	/// Methods
	async created() {
		const pagination = this.pagination ? this.pagination : {};

		this.paginationDefault = {
			...paginationDefault,
			...pagination,
		};
	}

	changeSort(column: string) {
		if (this.paginationDefault.sortBy === column) {
			this.paginationDefault.descending = !this.paginationDefault.descending;
		}
		else {
			this.paginationDefault.sortBy = column;
			this.paginationDefault.descending = false;
		}
	}


	get displayedItems() {
		if (this.fetchedItems) {
			return this.fetchedItems;
		}
		else {
			return this.items;
		}
	}
}
